module.exports = __webpack_public_path__ + "93a89ef2894bcbf6c82115737277da87.svg";